import React from 'react';
import { motion } from 'framer-motion';
import { OutlineXIcon } from '@tempmee/react-icons';


export default function JobPostingPopup({ children, closeModal }) {
  return (
    <div className="modal" onClick={closeModal}>
      <motion.div
        onClick={(event) => event.stopPropagation()}
        className="modal_content"
        style={{ position: 'relative' }}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <OutlineXIcon />

        {children}
      </motion.div>
    </div>
  );
}
